export enum EMAIL_STATUS {
	APPROVED = 'APPROVED',
	UNAPPROVED = 'UNAPPROVED',
}
